'use client';
import React from 'react';
import { Button, Tooltip } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { useChartUIContext } from '@/contexts';
import { useChartUIStoreSelector } from '@/stores/chartUIStore';

interface EditButtonProps {}

const EditButton = React.forwardRef<HTMLButtonElement, EditButtonProps>((_props, ref) => {
  const { chartUIStore } = useChartUIContext();
  const setIsPopupVisible = useChartUIStoreSelector(chartUIStore, s => s.setIsPopupVisible);

  const handleEditClick = () => {
    setIsPopupVisible(true);
  };

  return (
    <Tooltip title="Settings">
      <Button ref={ref} icon={<SettingOutlined />} onClick={handleEditClick} />
    </Tooltip>
  );
});

EditButton.displayName = 'EditButton';

export default EditButton;
